export const SET_LOADING = 'src/store/sponsors/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/sponsors/SET_SAVE_LOADING'
export const SET_SPONSORS = 'src/store/sponsors/SET_SPONSORS'
export const SET_SPONSOR = 'src/store/sponsors/SET_SPONSOR'
export const SET_SPONSOR_RESPONSE = 'src/store/sponsors/SET_SPONSOR_RESPONSE'
